import { HandoverKeys } from './../../../providers/ActivationObjectProvider/types/index';
import moment from 'moment'
import { getFormattedAddress } from '../../../../utils/GoogleMapsUtils'
import { isEmpty } from '../../../../utils/stringUtils'
import { ActivationObject, LegalObjectType, PhysicalObjectType } from '../../../providers/ActivationObjectProvider/types'
import { PersonAuthorisationTypes } from '../../Step1/constants'
import { LegalObjectTypeDesc, PhysicalObjectTypeDesc } from '../../Step2/constants'
import { ControlTypeDesc, LocationDogDesc } from '../../Step3/constants'
import { ServiceFutureDesc } from '../../Step5/constants'
import { Step6DataProps } from '../types'

const useStep6Data = (activationObject?: ActivationObject): Step6DataProps => {
    const handoverAll = ['Na pozemek i od objektu', 'Od vchodu i bytu', 'Vnitřní i vnější prostory']
    const handoverBuilding = ['Pouze na pozemek', 'Od vchodu', 'Vnější prostory']

    const handoverDescText = (handoverKeys: HandoverKeys) => {
        if (handoverKeys === 'LandAndObject') {
            if (activationObject?.objectType === 'FamilyHouse') {
                return handoverAll[0]
            } else if (activationObject?.objectType === 'Flat') {
                return handoverAll[1]
            } else {
                return handoverAll[2]
            }
        } else if (handoverKeys === 'OnlyLand') {
            if (activationObject?.objectType === 'FamilyHouse') {
                return handoverBuilding[0]
            } else if (activationObject?.objectType === 'Flat') {
                return handoverBuilding[1]
            } else {
                return handoverBuilding[2]
            }
        } else return 'Bez předání'
    }

    const houseNum = isEmpty(activationObject?.objectGuidanceNumber)
        ? activationObject?.objectCodeNumber
        : activationObject?.objectCodeNumber + '/' + activationObject?.objectGuidanceNumber

    const objecTypeText =
        activationObject && activationObject.personType && activationObject.objectType
            ? activationObject.personType === 'Legal'
                ? LegalObjectTypeDesc[activationObject.objectType as LegalObjectType]
                : PhysicalObjectTypeDesc[activationObject.objectType as PhysicalObjectType]
            : ''

    const invoiceAddressFormatted = activationObject
        ? (activationObject.personType === 'Legal' ? activationObject.invoiceAddressName : activationObject?.personName) +
          ', ' +
          getFormattedAddress(
              activationObject.invoiceAddressZIP,
              activationObject.invoiceAddressCity,
              activationObject.invoiceAddressStreet,
              activationObject.invoiceAddressCodeNumber,
              activationObject.invoiceAddressGuidanceNumber,
              false
          )
        : ''

    const booleanToText = (val?: boolean | null) => (val ? 'Ano' : 'Ne')
    return {
        ...activationObject,
        personTypeText: activationObject?.personType === 'Physical' ? 'Fyzická osoba' : 'Právnická osoba',
        permissionTypeText: activationObject?.personAuthorisationType
            ? PersonAuthorisationTypes[activationObject.personAuthorisationType]
            : '',
        useSettingsAnotherContractText: booleanToText(activationObject?.useSettingsAnotherContract),
        unifyInvoicingText: booleanToText(activationObject?.unifyInvoicing),
        addressFormatted:
            activationObject?.objectStreet +
            ' ' +
            (houseNum !== undefined && houseNum !== null && houseNum !== '' ? houseNum : ''),
        objecTypeText,
        objectSizeText: activationObject?.objectSize === 'LessOrEqual500' ? 'Do 500 m²' : 'Nad 500 m²',
        locationDogText: activationObject?.locationDog
            ? LocationDogDesc[activationObject.locationDog]
            : LocationDogDesc['NotPresent'],
        handoverKeysText: activationObject?.handoverKeys ?
            handoverDescText(activationObject.handoverKeys) : '',
        controlTypeText: activationObject?.controlType ? ControlTypeDesc[activationObject.controlType] : '',
        setControlChipsText: booleanToText(activationObject?.setControlChips),
        customerPresenceText: booleanToText(activationObject?.customerPresence),
        showChipping: activationObject?.setControlChips === true && activationObject?.handoverKeys === 'NotHandoverKeys',
        chippingDateText: activationObject?.handoverKeysDateTime
            ? `${moment(activationObject.handoverKeysDateTime).format('DD.MM.yyyy HH:mm')} - ${moment(activationObject.handoverKeysDateTime).add(2, 'hours').format('HH:mm')}`
            : '',
        instructionsSuitText: booleanToText(activationObject?.complyWithGuidelines),
        contactPersonsText:
            activationObject && activationObject.personContacts
                ? activationObject.personContacts.map((person) => {
                      return `${person.fullName}, ${person.phone}, ${person.email || ''} (${
                          person.role === 'Admin' ? 'Administrátor' : 'Uživatel'
                      })`
                  })
                : [],
        protectionStartText: activationObject?.startProtection
            ? moment(activationObject.startProtection).format('DD.MM.yyyy')
            : '',
        protectionEndText: activationObject?.endFreeProtection
            ? moment(activationObject.endFreeProtection).format('DD.MM.yyyy')
            : '',
        futureServiceText: activationObject?.serviceFuture !== undefined ? ServiceFutureDesc[activationObject.serviceFuture] : '',
        invoiceAddressFormatted,
    }
}

export default useStep6Data
